import { render } from "./FooterApp.vue?vue&type=template&id=e3cff814&scoped=true"
import script from "./FooterApp.vue?vue&type=script&lang=js"
export * from "./FooterApp.vue?vue&type=script&lang=js"

import "./FooterApp.vue?vue&type=style&index=0&id=e3cff814&lang=scss&scoped=true"

import exportComponent from "/Users/spineup/Downloads/Safe_Sites_Modifs/SAFE_ORTHO/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3cff814"]])

export default __exports__